export const USER_CORPORATE_DATA = "USER_CORPORATE_DATA"